module.exports = __webpack_public_path__ + "static/RoslindaleText-Bold-25c1fc85d541d837e198161d5ad742bc.woff";